module.exports = __webpack_public_path__ + "static/orderYes-20aef2914009f311de10a0039f1a1fb4.png";